<template>
  <div class='Box'>
    <el-card class="box-card">
      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="35">

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="账户ID">
              <el-input v-model="queryParams.id" @change="search" placeholder="请输入账户ID"
                        clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="关联主体" prop="subject_id">
              <el-select v-model="queryParams.subject_id" filterable @change="search" placeholder="请选择关联主体"
                         style="width: 90%;" clearable>
                <el-option v-for="dict in subjectList" :key="dict.id" :label="dict.name"
                           :value="dict.id"/>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="状态">
              <el-select v-model="queryParams.status" placeholder="请选择状态" @change="search" clearable style="width: 100%;">
                <el-option label="正常" :value="1"></el-option>
                <el-option label="禁用" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button type="primary" size="medium" @click="search">查询</el-button>
              <el-button @click="addNoNe" size="medium">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="div_buttom">
        <el-button size="medium" @click="addNoNe">刷新列表</el-button>
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="addList">添加</el-button>
      </div>
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                size="medium"
                :header-cell-style="{textAlign:'center',background:'#f5f7fa'}" :cell-style="{textAlign:'center'}"
                @selection-change="handleSelectionChange" border v-loading="loading">
        <el-table-column label="账户ID">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>

        <el-table-column prop="name" label="关联主体">
          <template slot-scope="scope">{{ scope.row.subject_text }}</template>
        </el-table-column>

        <el-table-column prop="name" label="收款公司名称">
          <template slot-scope="scope">{{ scope.row.subject_name }}</template>
        </el-table-column>

        <el-table-column prop="name" label="开户行名称">
          <template slot-scope="scope">{{ scope.row.bank }}</template>
        </el-table-column>

        <el-table-column prop="name" label="银行账号">
          <template slot-scope="scope">{{ scope.row.bank_account }}</template>
        </el-table-column>

        <el-table-column prop="name" label="状态">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status == 1">正常</el-tag>
            <el-tag type="danger" v-else>禁用</el-tag>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="addEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>

      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo"
                  :limit.sync="queryParams.pageSize" @pagination="getList('changePage')"/>
      <ReceivingAccountEdit v-if="AddReceivingAccountFlag" :AddReceivingAccountFlag="AddReceivingAccountFlag" @NoneDlog="NoneDlog" @AddOk="AddOk"
                    :editID="editID">
      </ReceivingAccountEdit>
    </el-card>
  </div>
</template>

<script>
import {MoneyManagementAPI} from '@/api/MoneyManagement/MoneyManagement';
import {processErrors} from "@/utils/errorHandler";
import ReceivingAccountEdit from "./edit.vue"

export default {
  components: {
    ReceivingAccountEdit
  },
  data() {
    return {
      form: {
        name: ""
      },
      SearchFlag: false,
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        name: "",
        id:''
      },
      appidList: [],
      page: {
        pageNo: 1,
        pageSize: 999,
      },

      tableData: [],
      multipleSelection: [],
      dialogVisible: false,
      editID: "",
      // 总条数
      total: 0,
      AddReceivingAccountFlag: false,
      loading: false,
      subjectList: {},
    };
  },
  created() {
    this.getSubjectSelect()
    this.getList()
  },
  methods: {

    getSubjectSelect() {
      let api = MoneyManagementAPI()
      api.getSubjectSelect().then(res => {
        if (res.code == 0) {
          this.subjectList = res.data
        } else {
          processErrors(res);
        }
      })
    },

    getList(type) {
      this.loading = true
      if(type != 'changePage'){
        this.queryParams.pageNo = 1
      }
      let api = MoneyManagementAPI()
      api.getReceivingAccountList(this.queryParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data
          this.total = res.data.totalCount
        } else {
          processErrors(res);
        }
        this.loading = false
      })
    },

    addSearch() {
      if (this.SearchFlag == false) {
        this.SearchFlag = true
      } else {
        this.SearchFlag = false
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    search() {
      this.getList()
    },
    addNoNe() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
        name: "",
        id:''
      }
      this.getList()
    },
    addList() {
      this.editID = ""
      this.AddReceivingAccountFlag = true
    },
    NoneDlog() {
      this.AddReceivingAccountFlag = false
    },
    AddOk() {
      this.editID = ""
      this.AddReceivingAccountFlag = false
      this.getList()
    },
    addEdit(row) {
      this.editID = row.id
      this.AddReceivingAccountFlag = true
    },
  },

  mounted() {

  },
}
</script>
<style lang='scss' scoped>
.Box {
  & ::v-deep el-card__body {

    padding: 0 !important;

  }
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}
</style>